<template>
    <div>
        <Head title="Profile moderation"/>

<!--        <pre>-->
<!--            {{form.profile.country}}-->
<!--            {{form.profile.sub_category}}-->
<!--            {{categories.Haare}}-->
<!--        </pre>-->

        <div class="text-center text-[30px] font-bold" v-if="firstname === ''">
            Alle Profile wurden moderiert.
        </div>

        <form @submit.prevent="update" class="relative" v-if="firstname !== ''">

            <div @click.prevent="hideScaledPhoto" class="hidden w-[100%] h-[100%] absolute z-50 hidden items-center justify-center hover:cursor-pointer" id="scaled_image" style="background-color: rgba(0,0,0,.4)">
                <img src="" alt="" id="scaled_image_src" class="scaled-image w-[100%] h-[100%] object-contain">
            </div>

            <div class="w-[100%] h-[100%] absolute z-50 hidden items-center justify-center" id="delete_popup" style="background-color: rgba(0,0,0,.4)">
                <div class="bg-white p-[15px]">
                    <div class="text-[16px] font-semibold mb-[10px]">Sind Sie sicher, dass Sie dieses Profil löschen möchten?</div>
                    <div class="flex justify-between">
                        <a class="bg-green-600 w-[48%] inline-block text-white text-[14px] text-center px-2 py-3 font-bold rounded-lg" @click.prevent="deleteProfile" href="#">Ja</a>
                        <a class="bg-red-600 w-[48%] inline-block text-white text-[14px] text-center px-2 py-3 font-bold rounded-lg" @click.prevent="closePopup" href="#">Nein</a>
                    </div>
                </div>
            </div>

            <div class="mb-5 leading-6 hidden">
                Profile, die nicht moderiert wurden: <b>{{nonModeratedProfiles}}</b><br>
                Profile, die moderiert wurden: <b>{{ allProfiles - nonModeratedProfiles }}</b>
            </div>

            <div class="flex justify-between">

                <div class="w-[48%]">
                    <!-- Photos -->
<!--                    <div id="photo_error" class="w-full mb-4 font-bold text-red-600 hidden">Bitte wählen Sie alle Optionen für Fotos</div>-->
<!--                    <div id="photo_error_profile_more2" class="w-full mb-4 font-bold text-red-600 hidden">Bitte wählen Sie 1 oder 2 Profilbilder</div>-->
                    <div class="flex justify-between items-start">
                        <h1 class="mb-4 text-3xl font-bold">1. Profilbilder <span class="text-[14px]">(um alle Fotos zu sehen, scrollen Sie innerhalb des Fotoblocks)</span></h1>
                    </div>
                    <div class="mb-[20px] text-[18px] font-semibold">Anzahl der Profilfotos: <b>{{form.profile.all_photos.length}}</b></div>

                    <div class="flex justify-between mb-4 w-full">
                        <a class="flex justify-center items-center text-[13px] text-white font-bold w-[30%] bg-orange-400 rounded-lg p-2" href="#" @click.prevent="selectPhotoCategory('normal')">Normal</a>
                        <a class="flex justify-center items-center text-[13px] text-white font-bold w-[30%] bg-orange-400 rounded-lg p-2" href="#" @click.prevent="selectPhotoCategory('adult')">FSK18</a>
                        <a class="flex justify-center items-center text-[13px] text-white font-bold w-[30%] bg-orange-400 rounded-lg p-2 text-center" href="#" @click.prevent="selectPhotoCategory('boobs')">Brust erkennbar</a>
                    </div>

                    <div class="flex w-full flex-wrap justify-between items-start mb-3 relative h-[610px] overflow-y-scroll">
                        <div v-for="(photo, key) in form.profile.all_photos" :class="'relative w-[32%] mb-6 border border-gray-300 p-2 rounded-lg photo-container photo_'+key">
                            <a href="#" @click.prevent="removePhoto(key)" class="absolute top-[5px] right-[5px] w-[24px] h-[24px] text-red-600">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </a>
                            <div class="text-center">
                                <input v-model="form.profile.profile_pictures" type="checkbox" :value="photo" :name="'photo_profile_'+key" :id="'photo_profile_'+key" class="peer hidden" />
<!--                                <input @change="mainPhotoSelected" v-model="form.profile.profile_picture" type="radio" :value="photo" name="photo_profile" :id="'photo_'+key" class="peer hidden" />-->
                                <label :for="'photo_profile_'+key" class="text-[12px] mb-2 text-center font-bold inline-block select-none cursor-pointer bg-white rounded-lg border border-gray-300 py-2 px-2 text-gray-300 transition-all duration-200 ease-in-out peer-checked:bg-green-600 peer-checked:text-white peer-checked:border-green-600">
                                    ProfilBild
                                </label>
                            </div>
                            <div class="h-[200px] mb-2">
                                <img :src="photo" alt="" @click.prevent="scalePhoto(key)" :class="'photo-image-list hover:cursor-pointer inline-block w-full h-full object-contain photo-image-'+key">
                            </div>
                            <div class="flex justify-between items-center">
                                <div class="w-[30%]">
                                    <input :checked="form.profile.no_nudes.includes(photo)" @input="updateProfilePhotos('no_nudes', photo)" type="radio" :value="photo" :name="'photo_type_'+key" :id="'photo_type_no_nude_'+key" class="peer hidden" />
                                    <label :id="'no_nude_label_'+key" :for="'photo_type_no_nude_'+key" :class="'photo_type_radio_' + key + ' text-center text-[8px] font-bold inline-block w-full select-none cursor-pointer bg-white rounded-lg border border-gray-300 py-2 px-1 text-gray-300 transition-all duration-200 ease-in-out peer-checked:bg-blue-600 peer-checked:text-white peer-checked:border-blue-600'">
                                        Normal
                                    </label>
                                </div>
                                <div class="w-[30%]">
                                    <input :checked="form.profile.adult.includes(photo)" @input="updateProfilePhotos('adult', photo)" type="radio" :value="photo" :name="'photo_type_'+key" :id="'photo_type_adult_'+key" class="peer hidden" />
                                    <label :id="'adult_label_'+key" :for="'photo_type_adult_'+key" :class="'photo_type_radio_' + key + ' text-center text-[8px] font-bold inline-block w-full select-none cursor-pointer bg-white rounded-lg border border-gray-300 py-2 px-1 text-gray-300 transition-all duration-200 ease-in-out peer-checked:bg-blue-600 peer-checked:text-white peer-checked:border-blue-600'">
                                        FSK18
                                    </label>
                                </div>
                                <div class="w-[30%]">
                                    <input :checked="form.profile.boobs.includes(photo)" @input="updateProfilePhotos('boobs', photo)" type="radio" :value="photo" :name="'photo_type_'+key" :id="'photo_type_boobs_'+key" class="peer hidden" />
                                    <label :id="'boobs_label_'+key" :for="'photo_type_boobs_'+key" :class="'photo_type_radio_' + key + ' text-center text-[8px] font-bold inline-block w-full select-none cursor-pointer bg-white rounded-lg border border-gray-300 py-2 px-1 text-gray-300 transition-all duration-200 ease-in-out peer-checked:bg-blue-600 peer-checked:text-white peer-checked:border-blue-600'">
                                        Brust erkennbar
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-[48%]">
                    <!-- Age group -->
<!--                    <div id="age_error" class="w-full mb-4 font-bold text-red-600 hidden">Bitte wählen Sie eine oder zwei benachbarte Kategorien aus</div>-->
                    <div class="flex justify-between">
                        <div class="w-[70%]">
                            <h1 class="mb-4 text-3xl font-bold">2. Altersgruppe</h1>
                            <div id="age_block" class="bg-white p-3 flex flex-wrap rounded-lg mb-8">

                                <div class="mr-3" v-for="age_group in age_groups">
                                    <input v-model="form.profile.age_group" type="checkbox" :value="age_group.value" :name="age_group.name" :id="age_group.value" class="peer hidden" />
                                    <label :for="age_group.value" class="text-sm font-bold text-center inline-block select-none cursor-pointer bg-blue-50 rounded-lg border border-gray-300 py-2 px-4 text-gray-600 transition-all duration-200 ease-in-out peer-checked:bg-blue-600 peer-checked:text-white peer-checked:border-blue-600">
                                        {{ age_group.value }}
                                    </label>
                                </div>

                            </div>
                        </div>
                        <div class="w-[28%]">
                            <h1 class="mb-4 text-3xl font-bold">3. Gender</h1>
                            <div class="bg-white p-3 flex flex-wrap rounded-lg mb-8">

                                <div>
                                    <input v-model="form.profile.gender" type="radio" value="male" name="gender" id="male" class="peer hidden" />
                                    <label id="male_label" for="male" class="mr-3 text-sm font-bold text-center inline-block select-none cursor-pointer bg-blue-50 rounded-lg border border-gray-300 py-2 px-4 text-gray-600 transition-all duration-200 ease-in-out peer-checked:bg-blue-600 peer-checked:text-white peer-checked:border-blue-600">
                                        Male
                                    </label>
                                </div>

                                <div>
                                    <input v-model="form.profile.gender" type="radio" value="female" name="gender" id="female" class="peer hidden" />
                                    <label id="female_label" for="female" class="text-sm font-bold text-center inline-block select-none cursor-pointer bg-blue-50 rounded-lg border border-gray-300 py-2 px-4 text-gray-600 transition-all duration-200 ease-in-out peer-checked:bg-blue-600 peer-checked:text-white peer-checked:border-blue-600">
                                        Female
                                    </label>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- Categories -->
<!--                    <div id="category_error" class="w-full mb-4 font-bold text-red-600 hidden">Bitte wählen Sie mindestens 1 Kategorie</div>-->
                    <h1 class="mb-4 text-3xl font-bold">4. Kategorien</h1>
                    <div id="category_block" class="bg-white p-3 flex flex-wrap justify-between rounded-lg mb-8">

                        <div class="w-[24%]">

                            <div class="w-[100%] rounded-md p-[8px] mb-3" style="background-color: #eee;">
                                <div class="mb-3"><b>Haare</b></div>
                                <div class="flex flex-wrap">
                                    <div v-for="category in categories.Haare" class="mr-2 mb-2">
                                        <input v-model="form.profile.sub_category" type="checkbox" :value="category.value" :name="category.name" :id="category.value" class="peer hidden" />
                                        <label :for="category.value" class="text-[12px] font-bold text-center inline-block select-none cursor-pointer bg-blue-50 rounded-lg border border-gray-300 py-[6px] px-[10px] text-gray-600 transition-all duration-200 ease-in-out peer-checked:bg-blue-600 peer-checked:text-white peer-checked:border-blue-600">
                                            {{ category.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="w-[100%] rounded-md p-[8px]" style="background-color: #eee;">
                                <div class="mb-3"><b>Körper</b></div>
                                <div class="flex flex-wrap">
                                    <div v-for="category in categories.Body" class="mr-2 mb-2">
                                        <input v-model="form.profile.sub_category" type="checkbox" :value="category.value" :name="category.name" :id="category.value" class="peer hidden" />
                                        <label :for="category.value" class="text-[12px] font-bold text-center inline-block select-none cursor-pointer bg-blue-50 rounded-lg border border-gray-300 py-[6px] px-[10px] text-gray-600 transition-all duration-200 ease-in-out peer-checked:bg-blue-600 peer-checked:text-white peer-checked:border-blue-600">
                                            {{ category.name }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="w-[36%] rounded-md p-[8px]" style="background-color: #eee;">
                            <div class="mb-3"><b>Sie hat auf den Bildern</b></div>
                            <div class="flex flex-wrap">
                                <div v-for="category in categories.Cat_norm" class="mr-2 mb-2">
                                    <input v-model="form.profile.sub_category" type="checkbox" :value="category.value" :name="category.name" :id="category.value" class="peer hidden" />
                                    <label @click="ageSelect(category.name)" :for="category.value" class="text-[12px] font-bold text-center inline-block select-none cursor-pointer bg-blue-50 rounded-lg border border-gray-300 py-[6px] px-[10px] text-gray-600 transition-all duration-200 ease-in-out peer-checked:bg-blue-600 peer-checked:text-white peer-checked:border-blue-600">
                                        {{ category.name }}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="w-[36%] rounded-md p-[8px]" style="background-color: #eee;">
                            <div class="mb-3"><b>Brust/FSK18</b></div>
                            <div class="flex flex-wrap">
                                <div v-for="category in categories.Cat_adult" class="mr-2 mb-2">
                                    <input v-model="form.profile.sub_category" type="checkbox" :value="category.value" :name="category.name" :id="category.value" class="peer hidden" />
                                    <label :for="category.value" class="text-[12px] font-bold text-center inline-block select-none cursor-pointer bg-blue-50 rounded-lg border border-gray-300 py-[6px] px-[10px] text-gray-600 transition-all duration-200 ease-in-out peer-checked:bg-blue-600 peer-checked:text-white peer-checked:border-blue-600">
                                        {{ category.name }}
                                    </label>
                                </div>
                            </div>
                        </div>

<!--                        <div class="w-[24%]" v-for="(category, key) in categories">-->
<!--                            <div v-if="key === 'Körper'">-->
<!--                                <div class="mb-3"><b>{{key}}</b></div>-->
<!--                                <div class="flex flex-wrap">-->
<!--                                    <div v-for="categoryitem in category" class="mr-2 mb-2">-->

<!--                                        <input v-model="form.profile.sub_category" type="checkbox" :value="categoryitem.value" :name="categoryitem.name" :id="categoryitem.value" class="peer hidden" />-->
<!--                                        <label :for="categoryitem.value" class="text-sm font-bold text-center inline-block select-none cursor-pointer bg-blue-50 rounded-lg border border-gray-300 py-2 px-4 text-gray-600 transition-all duration-200 ease-in-out peer-checked:bg-blue-600 peer-checked:text-white peer-checked:border-blue-600">-->
<!--                                            {{ categoryitem.name }}-->
<!--                                        </label>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>

                    <!-- Country -->
<!--                    <div id="country_error" class="w-full mb-4 font-bold text-red-600 hidden">Bitte wählen Sie mindestens 1 Land</div>-->
                    <div class="flex flex-wrap w-full justify-between mb-8">
                        <div class="w-full">
                            <h1 class="mb-4 text-3xl font-bold">5. Ländergruppe <a @click.prevent="allEurope" class="font-semibold text-[16px] text-blue-600 underline" href="#">All Europe</a></h1>
                            <div id="country_block" class="bg-white p-3 flex flex-wrap rounded-lg">
                                <div v-for="(country, key) in countries" class="mr-3 mb-2">
                                    <input v-model="form.profile.country" type="checkbox" :value="key" :name="key" :id="key" class="peer hidden" />
                                    <label :for="key" class="text-sm font-bold text-center inline-block select-none cursor-pointer bg-blue-50 rounded-lg border border-gray-300 py-2 px-4 text-gray-600 transition-all duration-200 ease-in-out peer-checked:bg-blue-600 peer-checked:text-white peer-checked:border-blue-600">
                                        {{key}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- General information -->
<!--                    <div id="name_error" class="w-full mb-4 font-bold text-red-600 hidden">Die Felder Vorname, Nachname und Spitzname müssen ausgefüllt werden.</div>-->
<!--                    <div id="nickname_error" class="w-full mb-4 font-bold text-red-600 hidden">Bitte ändern Sie die Namensdaten oder drücken Sie ok für jedes Feld.</div>-->
<!--                    <div id="nickname_error_duplicate" class="w-full mb-4 font-bold text-red-600 hidden">Dieser Nickname existiert bereits, bitte ändern Sie ihn.</div>-->
<!--                    <h1 class="mb-4 text-3xl font-bold">6. Allgemeine Informationen</h1>-->
<!--                    <div class="flex w-full flex-wrap justify-between mb-8">-->
<!--                        <div class="w-[30%] relative">-->
<!--                            <text-input v-model="form.profile.firstname" class="w-full input-firstname" label="Vorname"/>-->
<!--                            <div class="absolute right-0 top-0">-->
<!--                                <input type="checkbox" name="profile_firstname" id="profile_firstname" class="peer hidden" />-->
<!--                                <label id="profile_firstname_label" for="profile_firstname" class="py-[3px] px-[8px] text-[14px] font-bold rounded-md inline-block border bg-red-600 text-white hover:cursor-pointer peer-checked:text-white peer-checked:bg-green-600">-->
<!--                                    OK-->
<!--                                </label>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="w-[30%] relative">-->
<!--                            <text-input v-model="form.profile.lastname" class="w-full input-lastname" label="Nachname"/>-->
<!--                            <div class="absolute right-0 top-0">-->
<!--                                <input type="checkbox" name="profile_lastname" id="profile_lastname" class="peer hidden" />-->
<!--                                <label id="profile_lastname_label" for="profile_lastname" class="py-[3px] px-[8px] text-[14px] font-bold rounded-md inline-block border bg-red-600 text-white hover:cursor-pointer peer-checked:text-white peer-checked:bg-green-600">-->
<!--                                    OK-->
<!--                                </label>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="w-[30%] relative">-->
<!--                            <text-input v-model="form.profile.nickname" class="w-full input-nickname" label="Spitzname"/>-->
<!--                            <div class="absolute right-0 top-0">-->
<!--                                <input type="checkbox" name="profile_nickname" id="profile_nickname" class="peer hidden" />-->
<!--                                <label id="profile_nickname_label" for="profile_nickname" class="py-[3px] px-[8px] text-[14px] font-bold rounded-md inline-block border bg-red-600 text-white hover:cursor-pointer peer-checked:text-white peer-checked:bg-green-600">-->
<!--                                    OK-->
<!--                                </label>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

                    <div class="flex justify-between">
                        <loading-button :loading="form.processing" class="justify-center bg-green-600 text-white text-center px-2 py-3 font-bold rounded-lg w-[67%]" type="submit">
                            Speichern und Weiter
                        </loading-button>

                        <a class="w-[30%] bg-red-600 inline-block text-white text-[14px] text-center px-2 py-3 font-bold rounded-lg" @click.prevent="openDeletePopup" href="#">Profil löschen</a>
                    </div>

                    <div class="mb-[25px]"></div>
                    <div id="photo_error" class="w-full mb-4 font-bold text-red-600 hidden">Bitte wählen Sie alle Optionen für Fotos</div>
                    <div id="photo_error_profile_more2" class="w-full mb-4 font-bold text-red-600 hidden">Bitte wählen Sie 1 oder 2 Profilbilder</div>
                    <div id="age_error" class="w-full mb-4 font-bold text-red-600 hidden">Bitte wählen Sie eine, zwei oder drei Alterskategorien</div>
                    <div id="category_error" class="w-full mb-4 font-bold text-red-600 hidden">Bitte wählen Sie mindestens 1 Kategorie</div>
                    <div id="country_error" class="w-full mb-4 font-bold text-red-600 hidden">Bitte wählen Sie mindestens 1 Land</div>

                </div>

            </div>
        </form>

    </div>
</template>

<script>
import {Head} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import MultipleSelectInput from '@/Shared/MultipleSelectInput'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: {
        Head,
        MultipleSelectInput,
        SelectInput,
        TextInput,
        LoadingButton
    },
    layout: Layout,
    props: {
        profile: Object,
        countries: Object,
        categories: Array,
        age_groups: Array,
        nonModeratedProfiles: Number,
        allProfiles: Number,
        nickname: String,
        firstname: String,
        lastname: String
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                profile: this.profile
            })
        }
    },
    mounted() {
        let femaleLabel = document.getElementById("female_label");
        if (femaleLabel) {
            femaleLabel.click();
        }
        //document.getElementById("female_label").click();

        document.body.addEventListener("click", function (evt) {
            let imgToShow = document.getElementById("scaled_image");

            if( evt.target.classList.contains('photo-image-list') ) {
                // do nothing
            } else {
                if( imgToShow.classList.contains("inline-block") ) {
                    console.log('hide');
                    imgToShow.src = '';
                    imgToShow.classList.add("hidden");
                    imgToShow.classList.remove("inline-block");
                }
            }
        });
    },
    methods: {
        ageSelect(name){
            if(name === 'Teen') {
                document.getElementById("18-25").click();
            } else if(name === 'Milf') {
                document.getElementById("26-35").click();
                setTimeout(() => {
                    document.getElementById("36-45").click();
                }, 1);
                setTimeout(() => {
                    document.getElementById("46-60").click();
                }, 2);
            }
            //document.getElementById(elem).click();
        },
        allEurope(){
            document.getElementById("West Europe").click();
            setTimeout(() => {
                document.getElementById("South Europe").click();
            }, 5);
            setTimeout(() => {
                document.getElementById("East Europe").click();
            }, 10);
        },
        openDeletePopup(){
            let deletePopup = document.getElementById("delete_popup");
            deletePopup.classList.remove("hidden");
            deletePopup.classList.add("flex");
        },
        closePopup() {
            let deletePopup = document.getElementById("delete_popup");
            deletePopup.classList.add("hidden");
            deletePopup.classList.remove("flex");
        },
        mainPhotoSelected(event) {
            let photoClass = event.target.id;
            let allElements = document.getElementsByClassName("photo-container")
            for (let i = 0; i < allElements.length; i++) {
                allElements[i].classList.remove("bg-green-400");  //.style.backgroundColor = "rgb(241,245,248)";
            }
            let el = document.getElementsByClassName(photoClass)[0];//.style.backgroundColor = "rgb(155,225,180)";
            el.classList.add("bg-green-400");
        },
        selectPhotoCategory(type){

            let allPhotosLength = this.form.profile.all_photos.length;
            let radioId = 'no_nude_label_';
            if( type === 'adult' ) {
                radioId = 'adult_label_';
                if(!document.getElementById('sexy').checked) {
                    document.getElementById("sexy").click();
                }
            } else if( type === 'boobs' ) {
                radioId = 'boobs_label_';
                if(!document.getElementById('sexy').checked) {
                    document.getElementById("sexy").click();
                }
            }
            for (let i = 0; i < allPhotosLength; i++) {
                let id = radioId + i;
                document.getElementById(id).click();
            }
        },
        updateProfilePhotos(key, value){
            const keys = ['no_nudes', 'adult', 'boobs'];
            if(value){
                keys.forEach((item) => {
                    if( item != key ) {
                        if( this.form.profile[item].includes(value) ) {
                            const index = this.form.profile[item].indexOf(value);
                            this.form.profile[item].splice(index, 1);
                        }
                    } else {
                        this.form.profile[key].push(value);
                    }
                })
            }
        },
        checkData(block_id, block_name = ''){
            document.getElementById(block_id).style.display = 'block';
            document.getElementById(block_id).scrollIntoView({behavior: 'smooth'});
            if(block_name) {
                document.getElementById(block_name).classList.add("bg-red-300");
            }
        },
        removePhoto(key){
            this.form.profile.all_photos.splice(key, 1);
        },
        hideScaledPhoto(){
            let blockToShow = document.getElementById("scaled_image");
            let imgToShow = document.getElementById("scaled_image_src");
            imgToShow.src = '';
            blockToShow.classList.add("hidden");
            blockToShow.classList.remove("inline-block");
        },
        scalePhoto(key){
            let photoItem = document.getElementsByClassName('photo-image-' + key)[0];

            let blockToShow = document.getElementById("scaled_image");
            let imgToShow = document.getElementById("scaled_image_src");

            imgToShow.src = photoItem.src;
            blockToShow.classList.remove("hidden");
            blockToShow.classList.add("inline-block");
        },
        getRandomAge(ageGroups){

            let ages = [];
            ageGroups.forEach((item) => {
                if( item === "60+" ) {
                    ages.push(60);
                    ages.push(65);
                } else {
                    ages.push(Number(item.slice(0, 2)));
                    ages.push(Number(item.slice(3, 5)));
                }
            })
            let ageFrom = Math.min(...ages);
            let ageTo = Math.max(...ages);
            return Math.floor(Math.random() * (ageTo - ageFrom + 1) + ageFrom);
        },
        deleteProfile() {
            let currentObj = this;
            axios.post(`/profile-moderation/${this.profile.id}/delete`, {
                ...this.form.profile
            })
                .then(function (response) {
                    window.location.reload();
                })
                .catch(function (error) {
                    currentObj.output = error;
                });
        },
        update(e) {
            e.preventDefault();

            // let nicknameElem = document.getElementsByClassName("input-nickname")[0].getElementsByTagName("input")[0];
            // let firstnameElem = document.getElementsByClassName("input-firstname")[0].getElementsByTagName("input")[0];
            // let lastnameElem = document.getElementsByClassName("input-lastname")[0].getElementsByTagName("input")[0];
            // nicknameElem.classList.remove("border-red-500");
            // firstnameElem.classList.remove("border-red-500");
            // lastnameElem.classList.remove("border-red-500");

            if( this.form.profile.age_group.length > 0 ){
                this.form.profile.age = this.getRandomAge(this.form.profile.age_group);
            }

            // Validation
            document.getElementById('photo_error').style.display = 'none';
            document.getElementById('photo_error_profile_more2').style.display = 'none';
            // document.getElementById('name_error').style.display = 'none';
            // document.getElementById('nickname_error').style.display = 'none';
            // document.getElementById('nickname_error_duplicate').style.display = 'none';
            document.getElementById('category_error').style.display = 'none';
            document.getElementById('country_error').style.display = 'none';
            document.getElementById('age_error').style.display = 'none';
            document.getElementById("age_block").classList.remove("bg-red-300");
            document.getElementById("category_block").classList.remove("bg-red-300");
            document.getElementById("country_block").classList.remove("bg-red-300");

            // Check that we select all attributes for photos
            let photoGroups = this.form.profile.adult.length + this.form.profile.boobs.length + this.form.profile.no_nudes.length;
            if( this.form.profile.all_photos.length > photoGroups ) {
                this.checkData('photo_error');
                for (let i = 0; i < this.form.profile.all_photos.length; i++) {
                    let radioName = 'photo_type_' + i;
                    let photoClass = 'photo_' + i;
                    let checked = false;
                    let allElements = document.getElementsByName(radioName);

                    for (let i = 0; i < allElements.length; i++) {
                        if (allElements[i].type === 'radio' && allElements[i].checked) {
                            checked = true;
                        }
                    }

                    let element = document.getElementsByClassName(photoClass)[0];
                    if( !checked ){
                        element.classList.add("bg-red-300");
                    } else {
                        element.classList.remove("bg-red-300");
                    }
                }
                return false;
            } else {
                for (let i = 0; i < this.form.profile.all_photos.length; i++) {
                    let photoClass = 'photo_' + i;
                    let element = document.getElementsByClassName(photoClass)[0];
                    element.classList.remove("bg-red-300");
                }
            }

            // Check if profile pictures correctly selected
            if( this.form.profile.profile_pictures.length === 0 || this.form.profile.profile_pictures.length > 2 ) {
                this.checkData('photo_error_profile_more2');
                return false;
            }

            // Check if age category selected
            if( this.form.profile.age_group.length === 0 || this.form.profile.age_group.length > 3 ) {
                this.checkData('age_error', 'age_block');
                return false;
            }

            if( this.form.profile.age_group.length === 2 ) {
                if(
                    (document.getElementById('18-25').checked && document.getElementById('26-35').checked) ||
                    (document.getElementById('26-35').checked && document.getElementById('36-45').checked) ||
                    (document.getElementById('36-45').checked && document.getElementById('46-60').checked) ||
                    (document.getElementById('46-60').checked && document.getElementById('60+').checked)

                ) {
                    // OK
                } else {
                    this.checkData('age_error', 'age_block');
                    return false;
                }
            }

            if( this.form.profile.age_group.length === 3 ) {
                if(
                    (document.getElementById('18-25').checked && document.getElementById('26-35').checked && document.getElementById('36-45').checked) ||
                    (document.getElementById('26-35').checked && document.getElementById('36-45').checked && document.getElementById('46-60').checked) ||
                    (document.getElementById('36-45').checked && document.getElementById('46-60').checked && document.getElementById('60+').checked)
                ){
                    // OK
                } else {
                    this.checkData('age_error', 'age_block');
                    return false;
                }
            }

            // Check if category selected
            if( this.form.profile.sub_category.length === 0 ) {
                this.checkData('category_error', 'category_block');
                return false;
            }

            // Check if country selected
            if( this.form.profile.country.length === 0 ) {
                this.checkData('country_error', 'country_block');
                return false;
            }

            // Check that firstname, lastname and nickname not empty
            // if( !this.form.profile.firstname || !this.form.profile.lastname || !this.form.profile.nickname ) {
            //     this.checkData('name_error');
            //     return false;
            // }

            // Check firstname
            // if( !document.getElementById('profile_firstname').checked && this.firstname === this.form.profile.firstname ) {
            //     let element = document.getElementsByClassName("input-firstname")[0].getElementsByTagName("input")[0];
            //     element.classList.add("border-red-500");
            // }

            // Check lastname
            // if( !document.getElementById('profile_lastname').checked && this.lastname === this.form.profile.lastname ) {
            //     let element = document.getElementsByClassName("input-lastname")[0].getElementsByTagName("input")[0];
            //     element.classList.add("border-red-500");
            // }

            // Check nickname
            // if( !document.getElementById('profile_nickname').checked && this.nickname === this.form.profile.nickname ) {
            //     let element = document.getElementsByClassName("input-nickname")[0].getElementsByTagName("input")[0];
            //     element.classList.add("border-red-500");
            // }

            // Check all name data
            // if(
            //     (!document.getElementById('profile_firstname').checked && this.firstname === this.form.profile.firstname) ||
            //     (!document.getElementById('profile_lastname').checked && this.lastname === this.form.profile.lastname) ||
            //     (!document.getElementById('profile_nickname').checked && this.nickname === this.form.profile.nickname)
            // ) {
            //     this.checkData('nickname_error');
            //     return false;
            // }

            this.form.profile.is_moderated = true;
            this.form.profile.is_moderated2 = true;
            let currentObj = this;
            axios.post(`/profile-moderation/${this.profile.id}`, {
                ...this.form.profile
            })
                .then(function (response) {
                    console.log(response.data);
                    if( !response.data.success ) {
                        document.getElementById("nickname_error_duplicate").style.display = 'block';
                        document.getElementById("nickname_error_duplicate").scrollIntoView({behavior: 'smooth'});
                        return false;
                    }
                    window.location.reload();
                })
                .catch(function (error) {
                    currentObj.output = error;
                });
        }
    }
}
</script>
